export const FILTERS_STORAGE_KEY = 'performance_filters';
export const ALL_FILTER_VALUE = 'all';

export const FILTER_PARAMS = {
    DATE_FROM: 'date_from',
    DATE_TO: 'date_to',
    CAMPAIGN_ID: 'campaign_id',
    DEVICE_TYPE: 'device_type',
    CUSTOMER_TYPE: 'customer_type',
    DETAILIZATION_TAB: 'detailization_tab'
};

export const FILTER_PARAM_KEYS = Object.values(FILTER_PARAMS);
